import { Alert, Button } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import cantileverTheme from 'styles/cantileverTheme'

export const StickySaveBannerContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: ${({ theme }) => theme.forecast.background1};

  @media print {
    && {
      display: none;
    }
  }
`

interface NiiSaveBannerProps {
  hasChanges: boolean
  isLoading: boolean
  onReset: () => void
  onSave: () => Promise<void>
}

export const NiiSaveBanner: FC<NiiSaveBannerProps> = ({
  hasChanges,
  isLoading,
  onReset,
  onSave,
}) => {
  return (
    <>
      <StyledAlert
        title={hasChanges ? 'Save Changes?' : 'No Changes'}
        type={hasChanges ? 'warning' : 'success'}
        showIcon
        action={
          hasChanges && (
            <BannerActions>
              <CancelButton
                type='dashed'
                size='small'
                disabled={isLoading}
                onClick={onReset}>
                Reset
              </CancelButton>
              <SaveButton
                type='primary'
                size='small'
                disabled={isLoading}
                onClick={onSave}>
                Save
              </SaveButton>
            </BannerActions>
          )
        }
      />
    </>
  )
}

const StyledAlert = styled(Alert)`
  min-height: 48px;

  .ant-alert-content {
    display: flex;
    align-items: center;
  }
`

const BannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const CancelButton = styled(Button)`
  background-color: ${cantileverTheme.colors.grayscale['500']} !important;
`

const SaveButton = styled(Button)`
  background-color: ${cantileverTheme.colors.OceanBlue} !important;
`
